/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Promise}
 */
const RESET_STATE = state => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Update the file upload progress
 *
 * @param  {Object} state
 * @param  {Number} progress
 * @return {Promise}
 */
const UPDATE_UPLOAD_PROGRESS = (state, progress) => {
    state.uploadProgress = progress
}

/**
 * Set the retreived CSV mapping options
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
const SET_MAPPINGS = (state, payload) => {
    state.mapping = payload.mappings
    state.parsed_data = payload.parsed_data
    state.meta = payload.meta
    state.file_name = payload.file_name
    state.date = payload.date
    state.uploading = false
}

/**
 * Set errors
 *
 * @param  {Object} state
 * @return {Promise}
 */
const SET_MAPPINGS_ERROR = (state, error) => {
    state.error = error.response.data
    state.uploading = false
}

/**
 * Reset the error state
 *
 * @param  {Object} state
 * @return {Promise}
 */
const BEGIN_UPLOAD = state => {
    state.uploading = true
    state.error = null
}

/**
 * Shows the modal.
 *
 * @param      {Object}  state   state
 * @return     {Void}
 */
const SHOW_MODAL = state => {
    state.showModal = true
}

/**
 * Hides the modal.
 *
 * @param      {Object}  state   The state
 * @return     {Void}
 */
const HIDE_MODAL = state => {
    state.showModal = false
}

/**
 * Reset the state binding for a given row
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
const RESET_BINDING = (state, payload) => {
    Object.keys(state.mapping).forEach(item => {
        state.mapping[item].forEach(subItem => {
            if (subItem.label === payload.label) {
                subItem.csv_column = ''
            }
        })
    })
}

/**
 * Set a given binding on the state object
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
const SET_BINDING = (state, payload) => {
    Object.keys(state.mapping).forEach(cat => {
        state.mapping[cat] = state.mapping[cat].map(item => {
            if (item.csv_column === payload.value) {
                item.csv_column = null
            }
            return item
        })
    })
    state.mapping[payload.mapping][payload.idx].csv_column = payload.value
}

/**
 * Set the saving state attribute
 *
 * @param  {Object} state
 * @return {Promise}
 */
const SAVING_BINDINGS = state => {
    state.saveError = null
    state.saving = true
}

/**
 * Set the saved state attribute
 *
 * @param  {Object} state
 * @return {Promise}
 */
const FILE_IMPORTED = state => {
    state.saving = false
    state.saved = true
}

/**
 * Handle failed import
 *
 * @param  {Vo} state
 * @param  {Object} error
 * @return {Promise}
 */
const IMPORT_MAPPINGS_ERROR = (state, error) => {
    state.saving = false
    state.saved = false
    state.saveError = error.response.data.message
        ? error.response.data.message
        : 'There was a problem importing your mappings. Please review the mappings below and make any necessary corrections.'
}

/**
 * Handle a successful request for assistance on a failed file upload
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
const SUPPORT_REQUEST_SUCCESS = (state, payload) => {
    state.helpRequested = true
    state.requestingHelp = false
}

/**
 * Handle a failed request for assistance on a failed file upload
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
const SUPPORT_REQUEST_FAILURE = (state, error) => {
    state.helpRequested = true
    state.requestingHelp = false
}

/**
 * Set the loading indicator
 *
 * @param  {Object} state
 * @return {Promise}
 */
const REQUEST_FILE_ASSISTANCE = state => {
    state.requestingHelp = true
}

export default {
    SHOW_MODAL,
    HIDE_MODAL,
    SET_BINDING,
    RESET_STATE,
    BEGIN_UPLOAD,
    SET_MAPPINGS,
    RESET_BINDING,
    FILE_IMPORTED,
    SAVING_BINDINGS,
    SET_MAPPINGS_ERROR,
    IMPORT_MAPPINGS_ERROR,
    UPDATE_UPLOAD_PROGRESS,
    SUPPORT_REQUEST_SUCCESS,
    SUPPORT_REQUEST_FAILURE,
    REQUEST_FILE_ASSISTANCE
}



// WEBPACK FOOTER //
// ./src/state/modules/rental-income-importer/mutations.js